module.exports = __webpack_public_path__ + "img/box04_02.7ea9cc83.jpg";